.scrollbar {
  --scrollbar-track-width: 0.375rem;
  --scrollbar-track-background: var(--white);

  composes: scrollbar from '@/stylesheets/scrollbar.module.css';
}

.emojiModal {
  z-index: 5000;

  @media (min-width: 769px) {
    top: calc(100% + 0.625rem);
    left: 0;
    width: 20.25rem;
    height: 22rem;
  }

  &.ios {
    [frimousse-emoji] {
      font-size: 1.3125rem;

      @media (min-width: 400px) {
        font-size: 1.75rem;
      }

      @media (min-width: 769px) {
        font-size: 1.125rem;
      }
    }
  }

  .remove {
    flex: 0 0 auto;
    width: 2rem;
    height: 2rem;
    border-radius: 0.375rem;

    @media (min-width: 400px) {
      width: 2.375rem;
      height: 2.375rem;
    }

    @media (min-width: 769px) {
      width: 2rem;
      height: 2rem;
    }

    svg {
      width: 1.5625rem;
      height: 1.5625rem;

      @media (min-width: 769px) {
        width: 1.25rem;
        height: 1.25rem;
      }
    }
  }

  [frimousse-root] {
    display: flex;
    flex-direction: column;
    width: calc(100% + 2.25rem);
    height: 100%;
    max-height: 30rem;
    margin: -1.125rem;
    background: var(--neutral);
    isolation: isolate;

    @media (min-width: 769px) {
      width: calc(100% + 2.5rem);
      height: 22rem;
      max-height: unset;
      margin: -1.25rem;
    }
  }

  [frimousse-search] {
    z-index: 10;
    position: relative;
    flex: 0 0 auto;
    height: 2.875rem;
    margin: 0.5rem 0.5rem 0;
    padding: 0.625rem 0.875rem;
    border: 0.0625rem solid var(--neutral-200);
    border-radius: 0.625rem;
    color: var(--neutral-600);
    font-size: 1.125rem;
    line-height: 1.5625rem;
    background: var(--neutral-50);
    appearance: none;

    @media (min-width: 769px) {
      height: 2.625rem;
      font-size: 1rem;
    }
  }

  [frimousse-viewport] {
    position: relative;
    flex: 1;
    outline: none;
  }

  [frimousse-loading],
  [frimousse-empty] {
    display: flex;
    position: absolute;
    justify-content: center;
    align-items: center;
    color: #737373;
    font-size: 14px;
    inset: 0;
  }

  [frimousse-list] {
    user-select: none;
    padding-block-end: 6px;
  }

  [frimousse-category-header] {
    padding: 12px 12px 6px;
    color: #a1a1a1;
    font-weight: 500;
    font-size: 12px;
    text-transform: uppercase;
    letter-spacing: 0.025rem;
    background: var(--neutral);
  }

  [frimousse-row] {
    display: grid !important;
    justify-content: space-between;
    justify-content: space-between;
    padding-inline: 0.5rem;
    scroll-margin-block: 0.75rem;
    grid-template-columns: repeat(9, minmax(auto, 2rem));

    @media (min-width: 400px) {
      padding-inline: 0.625rem;
    }

    @media (min-width: 769px) {
      padding-inline: 0.75rem;
    }
  }

  [frimousse-emoji] {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 2rem;
    width: 2rem;
    height: 2rem;
    height: 2rem;
    padding: 0;
    border: none;
    border-radius: 6px;
    font-size: 1.3125rem;
    cursor: pointer;
    background: transparent;

    @media (min-width: 400px) {
      width: 2.375rem;
      height: 2.375rem;
      font-size: 1.375rem;
    }

    @media (min-width: 769px) {
      width: 2rem;
      height: 2rem;
      font-size: 1.125rem;
    }

    &[data-active] {
      background: var(--neutral-200);
    }
  }
}
